import React from "react";
import logo from "./../../media/icons/logo_novabank_footer.svg";
import twitterImg from "./../../media/icons/twitter.svg";
import facebookImg from "./../../media/icons/facebook.svg";
import locationImg from "./../../media/icons/icon_location_orange-02.svg";
import mailImg from "./../../media/icons/icon_msg_orange-02.svg";
import phoneImg from "./../../media/icons/icon_phone_orange-02.svg";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import setNavigation from "./../../actions/set_navigation";
import { Col } from "Components";
class Footer extends React.Component {
  render = () => (
    <div className="footer_wrapper">
      <div className="footer_bg_gray">
        <div className="container row">
          <Col l={3} m={12}>
            <img alt="" className="footer_logo" src={logo} />
            <div className="social_media">
              {this.props.config.facebook_url ? (
                <a target="_blank" href={this.props.config.facebook_url}>
                  <p>
                    <img alt="" src={facebookImg} /> Facebook
                  </p>
                </a>
              ) : null}
              {this.props.config.twitter_url ? (
                <a target="_blank" href={this.props.config.twitter_url}>
                  <p>
                    <img alt="" src={twitterImg} /> Twitter
                  </p>
                </a>
              ) : null}
            </div>
          </Col>
          <Col l={3} m={12} className="mt10">
            <p className="footer_link_title">FAYDALI LİNKLER</p>
            <ul className="footer_link_items">
              <Link
                onClick={() => this.props.setNavigation(["branches"])}
                to={"/branches"}
              >
                <li>Şubelerimiz ve Bankamatikler</li>
              </Link>
              <li>Fiyat, Oran ve Kurlar</li>
              <li>Ürün ve Hizmet Ücretleri</li>
              <li>Müşteri Memnuniyeti</li>
            </ul>
          </Col>
          <Col l={3} m={12} className="mt10">
            <ul className="footer_link_items pt10">
              <li>Gizlilik Politikası</li>
              <li>Kısa Yollar</li>
              <li>Faydalı Bilgiler</li>
              <Link
                onClick={() => this.props.setNavigation(["contact-us"])}
                to={"/contact-us"}
              >
                <li>İletişim</li>
              </Link>
            </ul>
          </Col>
          <Col l={3} m={12} className="mt10">
            <input className="footer_search" />
            <p className="information_item mt30">
              {" "}
              <img alt="" src={phoneImg} /> {this.props.config.phone}{" "}
            </p>
            <p className="information_item">
              {" "}
              <img alt="" src={mailImg} /> {this.props.config.email}{" "}
            </p>
            <p className="information_item">
              {" "}
              <img alt="" src={locationImg} /> {this.props.config.address}
            </p>
          </Col>
        </div>
      </div>
      <div className="footer_bg_orange">
        <div className="container">
          <p>Copyright © 2018. Novabank, Tüm hakları saklıdır.</p>
          <span>Designer by Reklam Odası</span>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  config: state.config ? state.config.data : {}
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNavigation
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);
